var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrokenLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 171,
    viewBox: "0 0 321 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.049 9.40522L132.72 0H29.7208C13.3064 0 0 13.1263 0 29.3185V140.729C0 156.921 13.3064 170.047 29.7208 170.047H291.263C307.678 170.047 320.984 156.921 320.984 140.729V29.3185C320.984 13.1263 307.678 0 291.263 0H146.791L152.77 6.02765L142.049 18.8624L147.41 28.3196L147.013 29.3185H151.239L154.828 26.1384L155.094 21.6606L155.271 18.6754L157.819 26.3161L155.855 29.3185H291.263V140.729H29.7208V29.3185H142.049V28.3196L132.669 18.8624L142.049 9.40522Z",
    fill: "url(#paint0_linear_1579_2491)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1579_2491",
    x1: -35.9191,
    y1: 19.0962,
    x2: 320.999,
    y2: 149.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70066,
    stopColor: "#E3E2E1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLogo);
export default __webpack_public_path__ + "static/media/broken-logo.e1753b6bd38c3bbe62ccaf87deeb8582.svg";
export { ForwardRef as ReactComponent };